import { render } from "./NotificationPage.vue?vue&type=template&id=a405d2a8&scoped=true&ts=true"
import script from "./NotificationPage.vue?vue&type=script&lang=ts"
export * from "./NotificationPage.vue?vue&type=script&lang=ts"

import "./NotificationPage.vue?vue&type=style&index=0&id=a405d2a8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a405d2a8"]])

export default __exports__